export const VERSION: string = "26.09.25 - 2 (PRO)";
